const DeliveryIndex = () => {
  return (
    <div>
      <div className="flex text-center border-b border-cusGray pt-3 font-bold">
        <div className="w-10">번호</div>
        <div className="flex-1">상품명</div>
        <div className="flex-1">연락처</div>
        <div className="text-white">다</div>
      </div>
    </div>
  );
};

export default DeliveryIndex;
